import React from 'react'
import image from '../../../assets/homepage_pro6.png'
const LowerBannerOne = () => {
    return (
        <>
            <div className="cate-bx common">
                <h3>Order for upcoming Gaming PC</h3>
                <p>Call today for a preorder the latest of processor </p>
                <figure className="cate-img">
                    <img className="img-fluid" src={image} alt="" />
                </figure>
                <a href="#" className="btn-buy">
                    Buy Now
                </a>
            </div>

        </>
    )
}

export default LowerBannerOne